import DatatableComponent from "../../../../../../components/common/DatatableComponent/DatatableComponent";
import FilterInTable from "../../../../../Manage/FilterInTable";

const All = () => {
    const data = [
        { name: 'Special Gift', code: "Voucher10", type: 'Store Credit', validityPeriod: '30 March - 7 April', value: 30, conditions: ['Min.spent: 20$', 'New customers only'], applicability: 'Electronics', redemption: 20, status: "Fully Redeemed" },
        { name: 'Special Gift', code: "Voucher10", type: 'Store Credit', validityPeriod: '30 March - 7 April', value: 30, conditions: ['Min.spent: 20$', 'New customers only'], applicability: 'Electronics', redemption: 20, status: "Fully Redeemed" },
        { name: 'Special Gift', code: "Voucher10", type: 'Store Credit', validityPeriod: '30 March - 7 April', value: 30, conditions: ['Min.spent: 20$', 'New customers only'], applicability: 'Electronics', redemption: 20, status: "Fully Redeemed" },
        { name: 'Special Gift', code: "Voucher10", type: 'Store Credit', validityPeriod: '30 March - 7 April', value: 30, conditions: ['Min.spent: 20$', 'New customers only'], applicability: 'Electronics', redemption: 20, status: "Fully Redeemed" },
    ];

    const columns = [
        {
            name: "Voucher Name",
            selector: (row) => row.name,
            minWidth: "140px",
        },
        {
            name: "Voucher Code",
            selector: (row) => row.code,
            minWidth: "140px",
        },
        {
            name: "Voucher Type",
            selector: (row) => row.type,
            minWidth: "140px",
        },
        {
            name: "Validity Period",
            selector: (row) => row.validityPeriod,
            minWidth: "140px",
        },
        {
            name: "Value",
            cell: (row) => <span>${row.value}</span>,
        },
        {
            name: "Conditions",
            cell: (row) => (
                <div>
                    {row.conditions.map((item) => (
                        <div>{item}</div>
                    ))}
                </div>
            ),
            minWidth: "180px",
        },
        {
            name: "Applicability",
            selector: (row) => row.applicability,
            minWidth: "140px",
        },
        {
            name: "Redemption",
            selector: (row) => <span>{row.redemption}%</span>,
            minWidth: "140px",
        },
        {
            name: "Status",
            selector: (row) => row.status,
            minWidth: "140px",
        },
    ];

    return (
        <div className="bg-white p-3">
            <div className="mb-3">
                <FilterInTable componentName="Vouchers All" />
            </div>

            <DatatableComponent
                responsive
                data={data}
                columns={columns}
                pagination
                type="gray-bordered"
            />
        </div>
    );
};

export default All;